module.exports = __webpack_public_path__ + "img/whats-new-15_cn.1c77303.jpg";